<template>
        <v-card class="img--main" elevation="0">
            <!-- <v-img :src="snap"  @click="click1"></v-img> -->
                    <div  style="display: none">
                        <input type="file" ref="input1" style="display: none" @change="previewImage" :accept="mime || 'image/gif,image/gif,image/jpeg,image/png,image/svg+xml'">
                    </div>

                    <div class="dropzone pa-3" :class="dragover ? 'pa-9' : 'pa-3'" :style="error ? `border: 1px solid red !important;` : (dragover ? `border: 1px solid #bce1ff !important; border-style: lighten-3; filter: brightness(90%); background: #ccc` : `border: 1px solid #949494 !important;`) "
                    @drop.prevent="onDrop" @dragover.prevent="dragover = true" @dragenter.prevent="dragover = true"
                    @dragleave.prevent="dragover = false" v-if="imageData != null || preview || snap" style="position: relative;"  @click="click1">
                    <!-- <v-btn color="grey"  icon class="img--main-pencil"><v-icon>mdi-pencil</v-icon></v-btn> -->
                    <v-chip outlined style="position: absolute; top: 5px; right: 5px; background-color: #fff !important; z-index: 1" label class="px-1 img--main-pencil" color="rgba(0, 0, 0, 0.2)"><v-icon color="black">mdi-pencil-outline</v-icon></v-chip>
                    <v-img class="preview relative" :height="height ? height : 280" :max-width="width ? width : '100%'" :width="width ? width : '100%'" cover :src="preview || snap" v-if="type == 'image'"></v-img>
                    <v-img class="preview relative" height="100" width="150" contain :src="preview || snap" v-else></v-img>
                        <br>
                    </div>
                    <div class="dropzone" :style="error ? `border-color: 1px solid red !important;` : (dragover ? `border: 1px solid #bce1ff !important; border-style: lighten-3;  filter: brightness(90%);background: #ccc` : `border: 1px solid #949494 !important;`) "
                    @drop.prevent="onDrop" @dragover.prevent="dragover = true" @dragenter.prevent="dragover = true"
                    @dragleave.prevent="dragover = false" v-else>
                        <v-card elevation="0" color="grey lighten-3 py-6 text-center" v-if="type == 'image'" @click="click1">
                            <v-icon size="128">mdi-image-outline</v-icon>
                            <div class="text-p text-secondary">{{ $t('common.drop_to_upload') }}                           </div>
                        </v-card>
                        <v-btn v-else color="primary" class="ma-1" @click="click1"><v-icon small class="mr-3">mdi-image</v-icon>{{ $t('common.selectFile')}}</v-btn>
                    </div>

        </v-card>
    </template>


<script>
import { getStorage, ref, getDownloadURL, uploadBytes } from "firebase/storage";
export default {
    data() {
        return {
            dragover: false,
            caption: '',
            preview: '',
            imageData: null,
            uploadValue: null,
            multiple: false,
            error: false
        }
    },
    props: {
        path: String,
        snap: String,
        mime: String,
        type: String,
        height: Number,
        width: Number
    },
    created(){
        this.preview = this.snap
    },
    methods: {
        create() {
            const post = {
                photo: this.img1,
                caption: this.caption
            }
        },
        click1() {
            this.$refs.input1.click()
        },
        previewImage(event) {
            this.uploadValue = 0;
            this.preview = null;
            this.imageData = event.target.files[0];
            this.onUpload()
        },
        onDrop(e) {
            e.preventDefault();
            if(!this.multiple){
                this.uploadValue = 0;
                this.preview = null;
                this.imageData = e.dataTransfer.files[0]
                this.onUpload()
            }
            else{
                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                    this.files.push(e.dataTransfer.files[i])
                }
            }
        },
        onUpload() {
            this.preview = null;
            const storage = getStorage();
            const f = this.path ? `${this.path}/${this.imageData.name}` : this.imageData.name
            console.log('F', f)
            const storageRef = ref(storage, f)
            uploadBytes(storageRef, this.imageData).then(() => {
            
                    getDownloadURL(storageRef).then((url) => {
                        this.$emit('change-url', url)
                        this.preview = url
                    });
                }
            );
        },
    }
}
</script>
<style lang="scss">
.img--main{
    .img--main-pencil{
        display: none;
    }
    &:hover{
        .img--main-pencil{
            display: block;
        }
    }
}
.dropzone{
    transition: .3s all;
    border-radius: 4px;
}
.relative{
    position: relative;
    z-index: 0;
}
</style>